import { get, patch } from './client.js';

const base = (wsId) => `/workspaces/${wsId}/notification-preferences`;

export const getAll        = (wsId)               => get(`${base(wsId)}`);
export const setPreference = (wsId, type, enabled) => patch(`${base(wsId)}/${type}`, { enabled });
